import React from 'react';
import { Route, Redirect } from 'react-router-dom';

// TODO: convert to gql, currentUser
const ManagerRoute = ({ component: Component, ...rest }) => (
  <Route {...rest} render={(props) => (
    localStorage.getItem("APN_USERTYPE") == process.env.REACT_APP_ADMIN_ROLE || 
                localStorage.getItem("APN_USERTYPE") == process.env.REACT_APP_PM_ROLE
      ? <Component {...props} />
      : <Redirect to='/notfound' />
  )} />
)

export default ManagerRoute;



// WEBPACK FOOTER //
// ./src/views/etc/ManagerRoute.js